// Packages
import React from 'react'
import AniLink from 'gatsby-plugin-transition-link/AniLink'

// Components
// import Logo from '@modules/common/components/Nav/Logo'

// Styles
import './styles/LandingPageNav.css'

interface Props {
  tagline?: string
}

// TODO: Launch opportunity modal on click of Get in Touch
const LandingPageNav = ({ tagline }: Props) => {
  return (
    <div>
      <nav className="LandingPageNav">
        <div className="LandingPageNav-inner">
          <AniLink
            bg="#0E0E1B"
            className="LandingPageNav-logo Nav-logo"
            cover
            direction="up"
            duration={1.5}
            to="/"
          >
            {/* <Logo /> */}
            <svg
              className="Nav-logo"
              fill="rgba(14, 14, 27, 1)"
              height="19"
              viewBox="0 0 99 19"
              width="99"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6.864 18L8.976 11.088L11.112 18H14.064L17.904 5.904H14.592L12.456 12.648L10.368 5.904H7.584L5.52 12.648L3.384 5.904H0.072L3.888 18H6.864ZM20.0392 12.024C20.0392 13.92 20.6392 15.432 21.8632 16.584C23.0872 17.712 24.6712 18.288 26.6632 18.288C28.7032 18.288 30.4552 17.544 31.8712 16.08L29.7832 14.088C28.9432 14.88 27.9592 15.264 26.8312 15.264C24.9352 15.264 23.6872 14.328 23.6152 12.888H32.7592C32.7832 12.528 32.8072 12.144 32.8072 11.736C32.8072 9.984 32.2312 8.544 31.0792 7.368C29.9272 6.192 28.4392 5.592 26.5912 5.592C24.6952 5.592 23.1112 6.168 21.8872 7.344C20.6632 8.496 20.0392 10.032 20.0392 11.928V12.024ZM23.6632 10.56C23.7592 9.432 25.0312 8.544 26.5912 8.544C28.0312 8.544 29.2072 9.432 29.2072 10.56H23.6632ZM40.1588 18V16.416C40.5188 17.472 41.9348 18.216 43.7588 18.216C45.4628 18.216 46.9028 17.616 48.0308 16.416C49.1828 15.192 49.7588 13.704 49.7588 11.952C49.7588 10.2 49.1828 8.712 48.0308 7.512C46.9028 6.288 45.4628 5.688 43.7588 5.688C41.9348 5.688 40.5188 6.432 40.1588 7.488V1.272H36.5828V18H40.1588ZM43.1108 14.976C42.2228 14.976 41.4788 14.688 40.8548 14.112C40.2548 13.512 39.9428 12.792 39.9428 11.952C39.9428 11.112 40.2548 10.392 40.8548 9.816C41.4788 9.216 42.2228 8.928 43.1108 8.928C43.9748 8.928 44.6948 9.216 45.2948 9.816C45.8948 10.392 46.1828 11.112 46.1828 11.952C46.1828 12.792 45.8948 13.512 45.2948 14.112C44.6948 14.688 43.9748 14.976 43.1108 14.976ZM53.4863 13.128C53.4863 14.808 54.0383 16.104 55.1423 16.992C56.2703 17.88 57.6623 18.336 59.3183 18.336C60.9743 18.336 62.3663 17.88 63.4703 16.992C64.5983 16.104 65.1503 14.808 65.1503 13.128V5.904H61.5263V12.816C61.5263 14.352 60.6383 15.048 59.3183 15.048C57.9983 15.048 57.1103 14.352 57.1103 12.816V5.904H53.4863V13.128ZM69.1704 2.856C69.1704 3.984 70.0824 4.872 71.2104 4.872C72.3384 4.872 73.2504 3.984 73.2504 2.856C73.2504 1.704 72.3384 0.816 71.2104 0.816C70.0824 0.816 69.1704 1.704 69.1704 2.856ZM73.0104 18V5.904H69.4344V18H73.0104ZM80.9869 18V1.272H77.4109V18H80.9869ZM90.8595 5.688C89.1555 5.688 87.7155 6.288 86.5635 7.512C85.4355 8.712 84.8595 10.2 84.8595 11.952C84.8595 13.704 85.4355 15.192 86.5635 16.416C87.7155 17.616 89.1555 18.216 90.8595 18.216C92.6835 18.216 94.0995 17.472 94.4595 16.416V18H98.0355V1.272H94.4595V7.488C94.0995 6.432 92.6835 5.688 90.8595 5.688ZM91.5075 14.976C90.6435 14.976 89.9235 14.688 89.3235 14.112C88.7235 13.512 88.4355 12.792 88.4355 11.952C88.4355 11.112 88.7235 10.392 89.3235 9.816C89.9235 9.216 90.6435 8.928 91.5075 8.928C92.3955 8.928 93.1395 9.216 93.7395 9.816C94.3635 10.392 94.6755 11.112 94.6755 11.952C94.6755 12.792 94.3635 13.512 93.7395 14.112C93.1395 14.688 92.3955 14.976 91.5075 14.976Z" />
            </svg>
            <span className="text-tag LandingPageNav-tagline">
              {tagline || null}
            </span>
          </AniLink>
          <div className="LandingPageNav-cta">
            <a href="mailto:hello@webuild.io" className="LandingPageNav-cta-link">
              Get In Touch
            </a>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default LandingPageNav
